var _circle, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgConversation(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 12.5,
    fill: "#F5F8FA",
    stroke: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.87413 19.0779C7.97227 19.2758 8.1744 19.4001 8.39413 19.4001L8.39467 19.4006H8.4096C8.52373 19.3974 11.0752 19.3105 12.2139 17.655H13.0485C16.8987 17.655 20.0304 15.1654 20.0304 12.1051C20.0304 9.06992 16.8987 6.60059 13.0485 6.60059C9.1984 6.60059 6.06667 9.06992 6.06667 12.1051C6.06667 14.0331 7.49013 15.5659 8.9392 16.2913C8.77928 17.3664 7.9865 18.3947 7.94115 18.4535C7.94007 18.4549 7.93941 18.4558 7.9392 18.4561C7.79893 18.6326 7.7728 18.8753 7.87413 19.0779ZM7.2304 12.1046C7.2304 9.71099 9.84053 7.76379 13.0485 7.76379V7.76432C16.2565 7.76432 18.8667 9.71152 18.8667 12.1051C18.8667 14.5238 16.2565 16.4913 13.0485 16.4913H11.8848C11.6672 16.4913 11.4677 16.6129 11.3675 16.8059C11.0101 17.4998 10.232 17.8582 9.56 18.0427C9.85547 17.4545 10.1301 16.6993 10.1301 15.927C10.1301 15.6891 9.9856 15.4753 9.76427 15.3867C8.50507 14.8843 7.2304 13.5963 7.2304 12.1046Z",
    fill: "#353F45"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConversation);
export default __webpack_public_path__ + "assets/media/Conversation.3deb6618.svg";
export { ForwardRef as ReactComponent };